import React from 'react';

/**
 * Logo officiel KadmiAI.
 * Props :
 *  - size (px) : taille du logo, défaut 32
 *  - variant : 'icon' | 'full' (icon seul OU icon + wordmark)
 *  - theme : 'light' | 'dark' (pour le wordmark)
 */
export const KadmiLogo = ({ size = 32, variant = 'icon', theme = 'dark', className = '', ...rest }) => {
  const iconId = `kadmi-grad-${Math.random().toString(36).slice(2, 8)}`;
  const sparkId = `kadmi-spark-${Math.random().toString(36).slice(2, 8)}`;

  const icon = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="KadmiAI logo"
      role="img"
    >
      <defs>
        <linearGradient id={iconId} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#4F7DE8" />
          <stop offset="55%" stopColor="#1E5BE0" />
          <stop offset="100%" stopColor="#0A2B8A" />
        </linearGradient>
        <radialGradient id={sparkId} cx="0.5" cy="0.5" r="0.5">
          <stop offset="0%" stopColor="#B0F3FF" />
          <stop offset="100%" stopColor="#00D9FF" />
        </radialGradient>
      </defs>

      {/* Rounded square background */}
      <rect width="64" height="64" rx="16" fill={`url(#${iconId})`} />

      {/* Subtle inner shine */}
      <rect x="2" y="2" width="60" height="60" rx="14" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="1" />

      {/* Letter K - clean modern geometric */}
      <g stroke="white" strokeWidth="5" strokeLinecap="round" fill="none">
        {/* vertical bar */}
        <path d="M 19 15 L 19 49" />
        {/* upper diagonal */}
        <path d="M 19 32 L 36 15" />
        {/* lower diagonal with slight curve suggesting a "paper fold" */}
        <path d="M 22 32 L 41 49" />
      </g>

      {/* AI sparkle — top right corner, glowing yellow */}
      <g>
        <circle cx="49" cy="15" r="3.8" fill={`url(#${sparkId})`} opacity="0.95" />
        <g stroke="#00D9FF" strokeWidth="1.6" strokeLinecap="round" opacity="0.9">
          <line x1="49" y1="8" x2="49" y2="12" />
          <line x1="49" y1="18" x2="49" y2="22" />
          <line x1="42" y1="15" x2="46" y2="15" />
          <line x1="52" y1="15" x2="56" y2="15" />
        </g>
      </g>
    </svg>
  );

  if (variant === 'icon') {
    return <span className={className} {...rest}>{icon}</span>;
  }

  const textColor = theme === 'light' ? '#0F0F1A' : '#ffffff';
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} {...rest}>
      {icon}
      <span
        style={{
          color: textColor,
          fontFamily: "'Sora','Inter',system-ui,sans-serif",
          fontWeight: 800,
          fontSize: Math.round(size * 0.6),
          letterSpacing: '-0.02em',
        }}
      >
        Kadmi<span style={{ color: '#1E5BE0' }}>AI</span>
      </span>
    </span>
  );
};

export default KadmiLogo;
